import type { UseMutationOptions } from "react-query";
import { useMutation } from "react-query";
import type { ApiError } from "@circle-react/config/CustomErrors";
import { reactQueryPost } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";

interface CreatePlanTrialParams {
  trial_type: string;
}

interface CreatePlanTrialResponse {
  error_details?: string[];
  success: boolean;
}

export const useCreatePlanTrial = (
  options?: UseMutationOptions<
    CreatePlanTrialResponse,
    ApiError,
    CreatePlanTrialParams
  >,
) => {
  const createPlanTrial = async (params: CreatePlanTrialParams) =>
    reactQueryPost<CreatePlanTrialResponse, CreatePlanTrialParams>(
      internalApi.planTrials.create(),
      params,
    );

  return useMutation<CreatePlanTrialResponse, ApiError, CreatePlanTrialParams>(
    createPlanTrial,
    options,
  );
};
